<!-- Translated: skip -->
<template>
  <Modal @close="closeModal" :wide="false" width="460px">
    <div class="addon-image default-image" :style="params.addon.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/svg/addons/' + params.addon.image + ');' : 'background-size: cover;'"></div>

    <h2>{{params.addon.arttext}}</h2>


    <p>{{params.addon.desc2}}</p>

    <p v-if="params.addon.included">1 st <span class="lowercase">{{params.addon.arttext}}</span> ingår alltid i ditt boende. Antalet du väljer är utöver det som redan ingår.</p>

    <div class="buttons" v-if="params.addon.auto !== 'T'">
      <!-- Select count -->
      <span class="quantity" v-if="!params.addon.added && params.addon.max_qty > 1"><input type="number" v-model="params.addon.qtySelected" /> <span style="font-weight:bold;">st</span></span>
      <!-- Picked count -->
      <button :class="'small ' + (params.addon.added ? 'green' : '') + ''" @click="removeArticle(params.addon)" v-if="params.addon.added">{{params.addon.qtySelected}}st valda</button>
      <!-- Trash -->
      <button :class="'small trash border'" @click="removeArticle(params.addon)" v-if="params.addon.added"><icon name="trash" :scale="1.3" /></button>
      <!-- Pick button -->
      <button :class="{small: true, disabled: !params.addon.qtySelected}" @click="chooseArticle(params.addon)" v-if="!params.addon.added && !params.addon.rut">Välj</button>
    </div>

    <p v-if="params.addon.auto === 'T'">
      {{ params.addon.autoTextLong || 'Detta tillval är obligatoriskt för detta boende.' }}
    </p>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import Dropdown from '@/components/components/Dropdown';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    Dropdown,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  computed: {
    isAddonBooking() {
      return this.$route.name === 'addons extra';
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'pickAccomodation',
      'addAddon',
      'removeAddon',
    ]),
    goTo(path) {
      this.closeModal();
      this.$router.push({ path });
    },
    chooseArticle(addon) {
      if (addon.qtySelected) {
        addon.added = true; // eslint-disable-line no-param-reassign

        if (this.isAddonBooking) {
          addon.belongsTo = -2; // eslint-disable-line no-param-reassign
        }

        this.addAddon(addon);
        this.closeModal();
      } else {
        this.openModal(['GeneralModal', {
          title: 'Välj antal',
          content: '<p>Du måste välj hur många du vill ha.</p>',
        }]);
      }
    },
    removeArticle(addon) {
      addon.added = false; // eslint-disable-line no-param-reassign
      this.removeAddon(addon);
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.addon-image
  margin-bottom 15px
  background-size contain
  background-repeat no-repeat
  background-position center
  height 120px
  width 120px
  display inline-block

h1
  font-size: 30px;
  font-weight: 900;
  margin-bottom 5px

h2
  font-size: 24px;
  font-weight: 900;
  text-align: center;
  color: #262626;
  united-heavy()

.modalo
  text-align center

.buttons
  margin-top 30px
  margin-bottom 30px
  display inline-block
  & > *
    float: left;
    margin-right: 5px;

input
  width 2.1em !important
  padding 3px 5px
  border-radius 3px
  background-color #ffffff
  border solid 1px light-blue-grey
  text-align center
.quantity
  display: inline-block;
  margin-right 10px

.lowercase
  text-transform lowercase
</style>



// WEBPACK FOOTER //
// AddonInfoModal.vue?0adfc9c8